import { root, id } from './sites';

export const sites = {
  ...root,
  id: {
    ...id,
  },
};
